import { render, staticRenderFns } from "./gsing.component.vue?vue&type=template&id=3050ecdf"
import script from "./gsing.component.ts?vue&type=script&lang=ts&external"
export * from "./gsing.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3050ecdf')) {
      api.createRecord('3050ecdf', component.options)
    } else {
      api.reload('3050ecdf', component.options)
    }
    module.hot.accept("./gsing.component.vue?vue&type=template&id=3050ecdf", function () {
      api.rerender('3050ecdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/gsing.component.vue"
export default component.exports